import React, { Component } from 'react';
import Filter from './Filter';
import './Work.scss';

const recent_work = {
  "items" : [
    { "name" : "Smart Agenda",
      "icon" : "/work/smartagenda_preview.png",
      "filters": ["web", "architecture"],
      "labels": ["website", "architecture"],
      "images": ['/work/screens/SmartAgenda_agenda.png','/work/screens/SmartAgenda_docs.png','/work/screens/SmartAgenda_users.png']
    },
    { "name" : "BarBot",
      "icon" : "/work/barbot_preview.png",
      "filters": ["mobile", "web", "architecture"],
      "labels": ["mobile", "website", "architecture"],
      "images": ['/work/screens/Barbot_login.png','/work/screens/Barbot_menu.png','/work/screens/Barbot_inventory.png','/work/screens/Barbot_ordering.png']
    },
    { "name" : "Workbar",
      "icon" : "/work/workbar_preview.jpg",
      "filters": ["web", "contributor"],
      "labels": ["website", "contributor"],
      "images": ['/work/screens/Workbar_members.jpg','/work/screens/Workbar_home.jpg','/work/screens/Workbar_book_a_room.jpg','/work/screens/Workbar_members_mobile.png']
    },
    { "name" : "First Circles",
      "icon" : "/work/firstcircles_preview.jpg",
      "filters": ["mobile", "web", "architecture"],
      "labels": ["mobile", "website", "architecture"],
      "images": ['/work/screens/FirstCircles_circle.png','/work/screens/Firstcircles_web.png','/work/screens/FirstCircles_requests.png','/work/screens/FirstCircles_android_request.png','/work/screens/FirstCircles_members.png']
    },
    { "name" : "Gravitater",
      "icon" : "/work/gravitater_preview.png",
      "filters": ["web", "contributor"],
      "labels": ["website", "contributor"],
      "images": ['/work/screens/Gravitater_overview.png','/work/screens/Gravitater_influencers.png','/work/screens/Gravitater_creative.png']
    },
    { "name" : "Retail Exchange",
      "icon" : "/work/rexchange_preview.jpg",
      "filters": ["mobile", "web", "architecture"],
      "labels": ["mobile", "website", "architecture"],
      "images": ['/work/screens/Retail_Exchange_lookbook_editor.png','/work/screens/Retail_Exchange_dashboard.png','/work/screens/Retail_Exchange_admin_users.png','/work/screens/Retail_Exchange_login_mobile.png']
    },
    { "name" : "Pretty Instant",
      "icon" : "/work/pretty_preview.jpg",
      "filters": ["mobile", "architecture", "contributor"],
      "labels": ["mobile", "architecture", "contributor"],
      "images": ['/work/screens/PrettyInstant_admin.jpg']
    },
    { "name" : "TapTape",
      "icon" : "/work/taptape_preview.jpg",
      "filters": ["web", "contributor"],
      "labels": ["website", "contributor"],
      "images": ['/work/screens/Taptape_home.jpg','/work/screens/Taptape_artist.jpg','/work/screens/Taptape_checkout.jpg','/work/screens/Taptape_merch.jpg']
    },
    { "name" : "Impact Mapper",
      "icon" : "/work/impact_preview.png",
      "filters": ["web", "contributor"],
      "labels": ["website", "contributor"],
      "images": ['/work/screens/Impactmapper_project.png','/work/screens/Impactmapper_tag.png','/work/screens/Impactmapper_chart1.png','/work/screens/Impactmapper_chart2.png']
    },
    { "name" : "GeoGo",
      "icon" : "/work/geogo_preview.png",
      "filters": ["mobile", "web", "architecture"],
      "labels": ["mobile", "website", "architecture"],
      "images": ['/work/screens/CMS_dashboard.png','/work/screens/CMS_session_visitors.png','/work/screens/CMS_heatmap.png','/work/screens/Swift_Flash_Memory_map.png','/work/screens/Swift_Flash_Memory_social.png','/work/screens/Swift_SAP_ipad_menu.png','/work/screens/Swift_TDA_ipad_menu.png']
    },
    { "name" : "Fan Pier",
      "icon" : "/work/fanpier_preview.jpg",
      "filters": ["mobile"],
      "labels": ["mobile"],
      "images": ['/work/screens/FanPier_about.png','/work/screens/FanPier_map.png','/work/screens/FanPier_video.png','/work/screens/FanPier_22liberty.png']
    }
  ]
}

export default class Work extends Component {
  render() {
    return (
      <section id="recent-work" className="section">
        <div className="container">
          <div className="section-title">
            <h2><span>My</span> Recent Work</h2>
          </div>

          <div className="portfolio-box">
            <div className="filter">
                <button type="button" className="control" data-filter="all">All</button>
                <button type="button" className="control" data-filter=".mobile">Native Mobile</button>
                <button type="button" className="control" data-filter=".web">Responsive Web</button>
                <button type="button" className="control" data-filter=".architecture">Architecture</button>
                <button type="button" className="control" data-filter=".contributor">Contributor</button>
            </div>

            <Filter opts={recent_work} />

          </div>
        </div>
      </section>


    );
  }
}



// WEBPACK FOOTER //
// ./src/Work.js